<template>
  <v-container fluid>
    <v-row justify-space-around row v-if="model">
      <v-col cols="3" mr-4>
        <v-card class="mb-4 pa-4">
          <v-card-title>Set Detail</v-card-title>
          <v-card-text class="pa-0">
            <v-list dense>
              <v-list-item>
                <v-list-item-content>Name:</v-list-item-content>
                <v-list-item-content class="align-end font-weight-bold">
                  <v-edit-dialog
                    :return-value.sync="model.name"
                    @save="saveName"
                  >
                    {{ model.name }}
                    <template v-slot:input>
                      <v-text-field
                        v-model="model.name"
                        label="Edit"
                        single-line
                        counter
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>Type:</v-list-item-content>
                <v-list-item-content class="align-end font-weight-bold">
                  {{ model.classification }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>Particles:</v-list-item-content>
                <v-list-item-content class="align-end font-weight-bold">
                  {{ model.particleList }}
                </v-list-item-content>
                <v-list-item-content class="align-end font-weight-bold">
                  <v-btn icon @click.stop="generateParticles()">
                    <v-icon>mdi-refresh</v-icon>
                  </v-btn>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>Validity:</v-list-item-content>
                <v-list-item-content class="align-end font-weight-bold">
                  {{ model.validity }}
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
        <v-card class="mb-4 pa-4">
          <v-card-title>Fields</v-card-title>
          <v-card-text>
            <v-list dense>
              <v-list-item v-for="field in model.fields" :key="field.id">
                <v-list-item-content>{{ field.handle }}:</v-list-item-content>
                <v-list-item-content class="align-end font-weight-bold">
                  <tip-form v-if="field.handle == 'tip'" :field="field" />
                  <template v-else>{{ field.value }}</template>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-actions>
              <AddField :set="model" @update="update"/>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="9" mr-4>
        <v-container fluid>
          <v-row>
            <v-col cols="12">
              <product-list
                store="products/index"
                :headers="productHeaders"
                :filters="{ setId: this.model.id }"
              ></product-list>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <prices
                :set="model"
                @update="update"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ProductList from "@components/products/ProductList.vue";
import TipForm from "@components/forms/sets/TipForm.vue";
import Prices from "@components/productSet/Price.vue";
import { mapActions, mapGetters } from "vuex";
import AddField from "../../components/productSet/AddField.vue";
export default {
  components: {
    ProductList,
    TipForm,
    Prices,
    AddField
},
  data: function() {
    return {
      setId: this.$route.params.id,
      loading: false,
      model: null,
      productHeaders: [
        { text: "Type", value: "type", align: "left" },
        { text: "Sku", value: "sku", align: "left" },
        //{ text: "Set", value: "set.name", align: "left" },
        { text: "Name", value: "name", align: "left" },
        { text: "Brand", value: "brand", align: "left" },
        { text: "On hand", value: "on_hand", align: "right" },
        { text: "Pending", value: "pending", align: "right" },
        { text: "Available", value: "available", align: "right" },
        { text: "Incoming", value: "incoming", align: "right" },
        { text: "Status", value: "status" },
        { text: "", value: "actions" },
      ],
    };
  },
  computed: {
    ...mapGetters("productSets", ["fieldHandles"]),
    ...mapGetters("catalogs", ["catalogs"]),
    shops: function() {
      return this.$store.getters["shops/shops"];
    },
  },
  watch: {
    $route() {
      if (this.$route.params.id) {
        this.setId = this.$route.params.id;
        this.getSet(this.$route.params.id);
      } else {
        this.$route.push("/sets");
      }
    },
  },
  mounted: function() {
    if (this.$route.params.id) {
      this.setId = this.$route.params.id;
      this.getSet(this.$route.params.id);
      this.getCatalogs();
    } else {
      this.$route.push("/sets");
    }
  },
  methods: {
    ...mapActions("productSets", ["getPrices"]),
    ...mapActions("catalogs", ["getCatalogs"]),
    getSet(id) {
      this.$store
        .dispatch("productSets/view", {
          id: id,
        })
        .then((data) => (this.model = data));
    },
    update() {
      this.getSet(this.$route.params.id);
      this.getCatalogs();
    },
    generateParticles() {
      this.loading = true;
      this.$store
        .dispatch("productSets/generateParticles", {
          id: this.setId,
        })
        .then((data) => (this.model = data.set))
        .finally(() => {
          this.loading = false;
        });
    },
    saveName() {
      this.loading = true;
      this.$store
        .dispatch("productSets/update", {
          model: this.model,
        })
        .then(({set}) => (this.model = set))
        .finally(() => {
          this.$store.dispatch("app/displaySnackBar", {
            text: "Set updated",
            color: "#28a745",
          });
        });
    },
  },
};
</script>

<style></style>
